import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl } from '../../../utils/Helper';
import { setRenderFlashMessage } from '../../../Redux/Actions/appConfigAction';
import { CustomTextInput } from '../../../components/customTextInput';
import CustomPressable from '../../../components/customPressable/customPressable';

const ReservationCreatePage = (props) => {
    const { preferredVenueDetails, venueAvailability, dailyProgrammeData, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { guestProfile } = useSelector(state => state.guestDetailsSlice?.currentGuestDetails);

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice?.extraConfigParam) || false;
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const { myReservations } = useSelector(state => state.tableReservationSlice);

    const [addionalDetailsData, setAdditionalDetailsData] = useState({
        "firstName": "",
        "lastName": "",
        "email": "",
        "phoneNumber": "",
        "guestComment": ""
    });

    const updateAdditionalDetailsData = (obj) => {
        setAdditionalDetailsData((state)=> ({
            ...state,
            ...obj
        }))
    }

    const handleGoNext = () => {

        if (!myReservations?.myReservationData?.length) {

            if (!addionalDetailsData.firstName) {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: t('reservations.enter_last_name') }))
                return;
            }

            if (!addionalDetailsData.lastName) {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: t('reservations.enter_last_name') }))
                return;
            }

            if (!addionalDetailsData.email || addionalDetailsData.email == "") {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter a valid email address" }))
                return;
            }

            if (!addionalDetailsData.phoneNumber || addionalDetailsData.phoneNumber == "") {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: t('reservations.enter_phone') }))
                return;
            }
    
        }

        handleNext(addionalDetailsData)
    }

    const updateDataFromProps = () => {
        setAdditionalDetailsData({ ...addionalDetailsData, firstName: preferredVenueDetails.firstName || guestProfile?.firstName, lastName: preferredVenueDetails.lastName || guestProfile?.lastName, email: preferredVenueDetails.email || guestProfile?.email, phoneNumber: preferredVenueDetails.phoneNumber || guestProfile?.phone, guestComment: preferredVenueDetails.guestComment })
    }

    useEffect(() => {
        updateDataFromProps();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guestProfile])


    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'sevenRoomsCreatePageHeaderContainer'])} id='sevenRoomsCreatePageHeaderContainer'>
                {
                    currentWidget?.widgetHeaderImageUrl && <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'sevenRoomsCreatePageHeaderImg'])} id={"sevenRoomsCreatePageHeaderImg"}/>
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'sevenRoomsCreatePageMainPageHeaderTitleContainer'])} id='sevenRoomsCreatePageMainPageHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'sevenRoomsCreatePageHeaderTitle'])} id='sevenRoomsCreatePageHeaderTitle'>{t('reservations.heading2a')}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'sevenRoomsCreatePageHeaderSubTitle'])} id='sevenRoomsCreatePageHeaderSubTitle'>{t('reservations.sub_heading2b')}</Text>
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'sevenRoomsCreatePageRootContainer'])} id="widgetRootContainer sevenRoomsCreatePageRootContainer">
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'sevenRoomsCreatePageMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='sevenRoomsCreatePageMainContainer'
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'sevenRoomsCreatePageMainContainerChildContainer'])} id='sevenRoomsCreatePageMainContainerChildContainer'>

                    <View style={getStyles(['textContainer',  'sevenRoomsCreatePageFirstNameContainer'])}>
                        <Text style={getStyles(['label', 'sevenRoomsCreatePageTextContainer',])}>{t('reservations.first_name')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            autoComplete
                            value={addionalDetailsData['firstName']}
                            onChangeText={(value) => updateAdditionalDetailsData({ "firstName": value })}
                            placeholder={t("reservations.first_name_placeholder")}
                        />
                    </View>
                    <View style={getStyles(['textContainer', 'sevenRoomsCreatePageLastNameContainer'])}>
                        <Text style={getStyles(['label', 'sevenRoomsCreatePageTextContainer'])}>{t('reservations.last_name')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            autoComplete
                            value={addionalDetailsData['lastName']}
                            onChangeText={(value) =>  updateAdditionalDetailsData({ "lastName": value })}
                            placeholder={t("reservations.last_name_placeholder")}
                        />
                    </View>
                    <View style={getStyles(['textContainer'])} id='textContainer'>
                        <Text style={getStyles(['label'])} id='label'>{t('h-commerce.email')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            placeholder="Enter your email address"
                            value={addionalDetailsData["email"]}
                            onChangeText={(value) => updateAdditionalDetailsData({ "email": value })}
                            autocomplete={"email"}
                        />
                    </View>
                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('reservations.phone')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            value={addionalDetailsData["phoneNumber"]}
                            onChangeText={(value) => updateAdditionalDetailsData({ "phoneNumber": value })}
                            placeholder={t('reservations.phone_placeholder')}
                            keyboardType="phone-pad"
                            maxLength={15}
                        />
                    </View>

                    <View style={getStyles(['textContainer'])} id='textContainer'>
                        <Text style={getStyles(['label'])} id='label'>{t('reservations.special_request')}</Text>
                        <CustomTextInput
                            style={{ height: 100 }}
                            value={addionalDetailsData["guestComment"]}
                            onChangeText={(value) => updateAdditionalDetailsData({ "guestComment": value })}
                            placeholder={t('reservations.special_request_placeholder')}
                            multiline
                            numberOfLines={3}
                        />
                    </View>
                </View>

                
            </ScrollView>
            <View style={getStyles(['sevenRoomsReservationDetails_button_container'])} id='sevenRoomsReservationDetails_button_container'>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleGoNext} id='primaryBtn'>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('reservations.make_reservation')}</Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack} id='secondaryBtn'>
                    <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('reservations.back')}</Text>
                </CustomPressable> */}
            </View>


        </View>
    )
}

export default ReservationCreatePage
